import { Dropdown, MenuProps, Select } from 'antd';
import DatePicker from "react-datepicker";
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
    CustomerAddress, CustomerAddressModel, CustomerContactDetailsModel, CustomerModel, CustomerWhatsappModelItem, IdentityType,
    Input, OfferModel, SpeakComappModelItem, SueModel, TreatmentFilterModel, TreatmentModel, TreatmentType
} from '../models/superbit-api-models';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { isRealGuid } from '../utils/guidUtils';
import { ViewMode } from './enums';
import ClientAddress from './_ClientAddress';
import ClientContact from './_ClientContact';
import ClientWhatsAppMessage from './_ClientWhatsAppMessage';
import { SimulatorModel } from '../models/SimulatorModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { WhatsAppModel } from '../models/WhatsAppModel';
import { useNavigate } from 'react-router-dom';
import Pagger from '../components/_Pagger';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { LeadsModel } from '../models/LeadsModel';
import LeadsTable from '../leads/_LeadsTable';
import './client-leads-container.css';
import CallsTable from '../calls/_CallsTable';
import ClientPolicyTable from './_ClientPolicyTable';
import Footer from '../_Footer';
import { IDNameDescriptionDictionary } from '../models/Site';
import TasksClientDetails from './TasksClientDetails';
import ClientDetailsViewMode from './_ClientDetailsViewMode';
import { useDispatch } from 'react-redux';
import { setEmailSubjectDetails, setTypeTreatmentsAction } from '../app-context/tasksSlice';
import Sues from '../sues/Sues';
import PoliciesDocumentsClientDetails from './_PoliciesDocumentsClientDetails';
import ClientPolicyEditPopup from './createPolicyManually/_ClientPolicyEdit';
import PoliciesDocuments from './PolicyDetails/_PoliciesDocuments';
import PoliciesClientDetails from './_PoliciesClientDetails';
import { cloneDeep } from 'lodash';
import {buildRidersTree,RidersData} from '../subscribers/SubscriberHelper'

type Props = {
    customerId: string;
    tabData: any;
    config: any;
    // mode: ViewMode;
    setLoading: Function;
    updateEditData: Function;
    updateMode: Function;
    setPopupShow?: React.Dispatch<React.SetStateAction<boolean>>;
    setMessege?: React.Dispatch<React.SetStateAction<string>>;
    onRowSelect?: Function;
};

type dataErrors = {
    identifier: boolean;
    identifierMessage: string;
    firstName?: boolean;
    lastName?: boolean;
    workplace?: boolean
}

const ClientDetails = (props: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const leadsModel: LeadsModel = new LeadsModel()
    const whatsAppModel: WhatsAppModel = new WhatsAppModel();

    const OpenDateFromRef = React.createRef<DatePicker>();

    const [mode, setMode] = useState<ViewMode>(ViewMode.VIEW)
    const [tab, setTab] = useState<string>('CustomerCard');
    const [personalData, setPersonalData] = useState<any>({});
    const [offersList, setOffersList] = useState<OfferModel[]>([]);
    const [suesList, setSuesList] = useState<SueModel[]>([]);
    const [whatsAppList, setWhatsAppList] = useState<CustomerWhatsappModelItem[]>([]);
    const [callItemsList, setCallItemsList] = useState<SpeakComappModelItem[]>([]);
    const [dataForEdit, setDataForEdit] = useState<CustomerModel>(props.tabData.editData ? new CustomerModel(props.tabData.editData) : new CustomerModel(props.tabData.personalData.customerData))
    const [identityIssueDate, setIdentityIssueDate] = useState<Date | null>(null)
    const [dateOfBirth, setDateOfBirth] = useState<Date | null>(null)
    const [driverLicensIssueDate, setDriverLicensIssueDate] = useState<Date | null>()
    // driverLicensIssueDate
    const [customerAge, setCustomerAge] = useState<string>('')
    const [isPerson, setIsPerson] = useState<boolean>(true);
    const [clientDataErrors, setClientDataErrors] = useState<dataErrors>({
        identifier: false,
        identifierMessage: '',
        firstName: false,
        lastName: false,
        workplace: false
    });
    const [apiUrl, setApiUrl] = useState<string | null>(null);

    const [martialStatuses, setMartialStatuses] = useState<any[]>([]);
    const [genders, setGenders] = useState<any[]>([]);
    // const [haetailsErrors, setDetailsErrors] = useState<any[]>([]);

    // SpeakCom
    const [speakComItems, setSpeakComItems] = useState<any[]>([]);
    const currYear: number = parseInt(moment().format('YYYY'));
    const [speakComFilter, setSpeakComFilter] = useState<any>({
        CustomerId: props.customerId,
        StartDate: moment().year(currYear - 1).toISOString(),
        EndDate: moment().toISOString()
    });
    // SpeakCom
    // Treatments Filter
    const [treatmentsList, setTreatmentsList] = useState<any[]>([]);
    const [treatmentsFilter, setTreatmentsFilter] = useState<TreatmentFilterModel>(
        new TreatmentFilterModel({
            page: 1,
            customerId: props.customerId
        })
    );
    const [treatmentsTimeoutId, setTreatmentsTimeoutId] = useState<number | any | null>(undefined);

    // Treatments Filter End

    //  Policy Filter 
    const [policySeachText, setPolicySearchText] = useState<string>('');
    const [policyTimeoutId, setPolicyTimeoutId] = useState<number | any | null>(undefined);
    const [policyTypes, setPolicyTypes] = useState<any[]>([]);
    const [policiesList, setPoliciesList] = useState<any[]>([]);
    const [ridersList, setRidersList] = useState<any[]>([]);
    const [policyFilter, setPolicyFilter] = useState<any>({
        page: 1,
        customerId: props.customerId,
        searchTerm: '',
        from: undefined,
        to: undefined,
        policyType: undefined,
    });
    const [policiesPagerConf, setPoliciesPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    //  Policy Filter  End
    //  Suggestions (Leads) Filter
    const [leadsTimeoutId, setLeadsTimeoutId] = useState<number | any | null>(undefined);
    const [leadsList, setLeadsList] = useState<any[]>([]);
    const [leadPolcyTypes, setLeadpolicyTypes] = useState<any[]>([
        {
            label: 'סוג ביטוח',
            value: '0'
        },
        {
            label: 'רכב',
            value: '1'
        },
        {
            label: 'דירה/עסק',
            value: '2'
        },
        {
            label: 'אחר',
            value: '3'
        },
    ]);

    const [leadsSearchText, setLeadsSearchText] = useState<string>()
    const [leadsFilter, setLeadsFilter] = useState<any>({
        page: 1,
        customerId: props.customerId,
        StatusIdSearch: undefined,
        searchText: undefined,
        policyType: undefined
    });
    const [leadStatuses, setLeadStatuses] = useState<any[]>([]);
    const [suggestionsPagerConf, setSuggestionsPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    //  Suggestions Filter  End
    // Documents
    const [documentsSearchText, setDocumentsSearchText] = useState<string>()
    const [documentsTimeoutId, setDocumentsTimeoutId] = useState<number | any | null>(undefined);
    const [documentsList, setDocumentsList] = useState<any[]>([]);
    const [documentsFilter, setDocumentsFilter] = useState<any>({
        page: 1,
        customerId: props.customerId,
        searchTerm: '',
        from: undefined,
        to: undefined
    });
    const [documentsPagerConf, setDocumentsPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    const [documentsAllData, setDocumentsAllData] = useState<number>(0);
    const [clientDocumentUrl, setClientDocumentUrl] = useState<string | null>(null)
    // Documents end
    // whatsApp
    const [whatsAppItemsList, setWhatsAppItemsList] = useState<any[]>([]);
    const [whatsAppFilter, setWhatsAppFilter] = useState<any>({
        type: "all",
        customerId: props.customerId
    });
    // whatsApp End
    // Calls

    const [callsPagerConf, setCallsPagerConf] = useState<any>({
        pageSize: 50,
        currentPage: 1,
        totalItems: 0
    });
    // Calls end
    const [creatorsOptions, setCreatorsOptions] = useState<any[]>([]);
    const [handlersOptions, setHandlersrsOptions] = useState<any[]>([]);

    // const [addPoliciesOptions, setAddPoliciesOptions] = useState<MenuProps['items']>([]);
    // const [policyTypeFilter, setPolicyTypeFilter] = useState<string>('-2');

    const [allRowsCounter, setAllRowsCounter] = useState<number>(0);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);

    const [addressTypes, setAddressTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());

    const [showModelUploadDocument, setShowModelUploadDocument] = useState<{ show: boolean, customerId: string }>({ show: false, customerId: '' });

    // policies
    // const [showPolicyEditPopUp, setShowPolcyEditPopup] = useState<boolean>(false);
    // const [policyEditType, setPolicyEditType] = useState<string>('')

    const policyTypesObj: any = {
        '0': {
            id: 0,
            name: 'סוג ביטוח',
            description: 'סוג ביטוח'
        },
        '1': {
            id: 1,
            name: 'רכב',
            description: 'רכב'
        },
        '2': {
            id: 2,
            name: 'דירה/עסק',
            description: 'דירה/עסק'
        },
        '3': {
            id: 3,
            name: 'עסק',
            description: 'עסק'
        },
        '4': {
            id: 4,
            name: 'חיים',
            description: 'חיים'
        },
        '5': {
            id: 5,
            name: 'בריאות',
            description: 'בריאות'
        },
        '6': {
            id: 6,
            name: 'אחריות מקצועית',
            description: 'אחריות מקצועית'
        },
        '7': {
            id: 7,
            name: 'ביטוח חבויות',
            description: 'ביטוח חבויות'
        },
        '8': {
            id: 8,
            name: 'ביטוח נסיעות לחו"ל',
            description: 'ביטוח נסיעות לחו"ל'
        },
        '9': {
            id: 9,
            name: 'ביטוח צ.מ.ה',
            description: 'ביטוח צ.מ.ה'
        },
        '10': {
            id: 10,
            name: 'ביטוח תאונות אישיות',
            description: 'ביטוח תאונות אישיות'
        },
        '11': {
            id: 11,
            name: 'חקלאי',
            description: 'חקלאי'
        },
        '12': {
            id: 12,
            name: 'ימי/אווירי',
            description: 'ימי/אווירי'
        },
        '13': {
            id: 13,
            name: 'כתב שרות',
            description: 'כתב שרות'
        },
        '14': {
            id: 14,
            name: 'סחורה בהעברה',
            description: 'סחורה בהעברה'
        },
        '15': {
            id: 15,
            name: 'עובדים זרים',
            description: 'עובדים זרים'
        },
        '16': {
            id: 16,
            name: 'קבלנים',
            description: 'קבלנים'
        },
        '17': {
            id: 17,
            name: 'שוק ההון',
            description: 'שוק ההון'
        },
        // '18': {
        //     id: 18,
        //     name: 'שוק ההון',
        //     description: 'שוק ההון'
        // },
        '19': {
            id: 19,
            name: 'הלוואה חברתית',
            description: 'הלוואה חברתית'
        },
        '20': {
            id: 20,
            name: 'שירותי דרך',
            description: 'שירותי דרך'
        },
        '21': {
            id: 21,
            name: 'חיות',
            description: 'חיות'
        },
        '22': {
            id: 22,
            name: 'עמדת טעינה',
            description: 'עמדת טעינה'
        }
    }

    const emptyFunc = () => { }

    // const openPolicyEditPopUp = (type: string) => {
    //     openPolicEditPopUp(true, type);

    // }

    const init = async () => {
        const savedApiUrl = localStorage.getItem('apiUrl');
        if (savedApiUrl) {
            setApiUrl(savedApiUrl)
        }

        
        const types = await simulatorModel.getAddressTypes();
        setAddressTypes(types);

    }


    const getTrearmentData = () => {
        getTreatments();
    }

    const getMaritalStatus = (id: string) => {
        const status = martialStatuses.find((i: any) => i.value == id)
        // console.log('getMaritalStatus', id, status, martialStatuses);
        return status ? status.label : 'N/A';
    }
    const getGender = (id: string) => {
        const status = genders.find((i: any) => i.value == id)
        return status ? status.label : 'N/A';
    }

    // speakComFilter
    const getSpeakComItems = async (filter?: any) => {
        if (!isRealGuid(props.customerId)) return; // unsaved customer has a temp (non-GUID) id — skip the server call
        props.setLoading(true);
        if (!filter) {
            filter = speakComFilter;
        }
        setSpeakComItems([]);
        const speakComData = await customerCardModel.speakComFilter(filter);
        if (speakComData && speakComData.length > 0) {
            // setSpeakComItems(speakComData);
            // speakComData.sort((a: any,b: any) => b.start_stamp - a.start_stamp);
            // speakComData.sort((a: SpeakComappModelItem,b: SpeakComappModelItem) => moment(b.start_stamp).isAfter(moment(a.start_stamp)) )
            speakComData.forEach((item: SpeakComappModelItem) => {
                // console.log(item.start_stamp, moment(item.start_stamp));
            });

            const speakComItems = speakComData.sort((a: SpeakComappModelItem, b: SpeakComappModelItem) => {
                // console.log('getSpeakComItems', moment(b.start_stamp).format('DD-MM-YYYY HH:mm'), moment(a.start_stamp).format('DD-MM-YYYY HH:mm'), moment(b.start_stamp).isAfter(moment(a.start_stamp)));
                let result = 0;
                if (moment(b.start_stamp).isAfter(moment(a.start_stamp))) {
                    result = 1;
                } else {
                    result = -1
                }
                return result;
            })
            setCallItemsList(speakComItems);
            setCallsPagerConf({
                pageSize: 50,
                currentPage: 0,
                totalItems: speakComData.length
            })
            // console.log('getSpeakComItems', speakComData)
        }
        props.setLoading(false);
    }


    // speakComFilter end 


    // treatments function
    const getTreatments = async (filter?: TreatmentFilterModel) => {
        if (!isRealGuid(props.customerId)) return; // unsaved customer has a temp (non-GUID) id — skip the server call
        props.setLoading(true);
        if (!filter) {
            filter = treatmentsFilter;
        }
        console.log('getTreatments', filter)
        const treatmentsData = await customerCardModel.treatmentsFilter(filter);
        const treatments: any[] = [];
        if (treatmentsData.items && treatmentsData.items.length > 0) {
            treatmentsData.items.forEach((item: any) => {
                treatments.push(item);
            })
        }

        const treatmentsSorted = treatments.sort((a: any, b: any) => {
            const dateA = new Date(a.createdDate);
            const dateB = new Date(b.createdDate);
            // Sort by eventDate in descending order
            return dateB.getTime() > dateA.getTime() ? 1 : -1;
        });

        console.log('treatmentsData', treatmentsData, treatmentsSorted);
        setTreatmentsList(treatmentsSorted);
        props.setLoading(false);
    }

    // treatments function end

    // leads functions
    const getLeads = async (filter?: any) => {
        if (!isRealGuid(props.customerId)) return; // unsaved customer has a temp (non-GUID) id — skip the server call
        setLeadsList([]);
        props.setLoading(true);
        if (!filter) {
            filter = leadsFilter;
        }
        const suggestionsData = await leadsModel.filter(filter);
        const suggestions: any[] = [];
        if (suggestionsData.leads && suggestionsData.leads.length > 0) {
            suggestionsData.leads.forEach((item: any) => {
                suggestions.push(item);
            })
        }
        setLeadsList(suggestions);
        // console.log('getLeads', suggestions)
        props.setLoading(false);
    }

    const getLeadStatuses = async () => {
        let statuses: any[] = []
        const leadStatusesList = localStorage.getItem('leadStatuses');
        if (leadStatusesList) {
            statuses = JSON.parse(leadStatusesList);
        } else {
            const data = await leadsModel.getLeadStatuses();
            if (data) {
                statuses = data;
                localStorage.setItem('leadStatuses', JSON.stringify(data))
            }
        }
        const newStatusList = statuses.map((status: any) => {
            return {
                label: status.text,
                value: status.value
            };
        })
        const allStatuses = [{
            label: 'כל הסטטוס',
            value: '0'
        }]
        setLeadStatuses(allStatuses.concat(newStatusList));
        // if (leadStatuses.length==0) {
        //     const statuses = await leadsModel.getLeadStatuses();
        //     console.log('getLeadStatuses', statuses);
        //     setLeadStatuses(statuses);
        // }
    }

    const handleLeadsSearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setLeadsSearchText(newSearchText);
        const newFilter = leadsFilter;
        newFilter.searchText = newSearchText;
        setLeadsFilter(newFilter);
        clearTimeout(leadsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            getLeads(newFilter);
        }, 1000);
        setLeadsTimeoutId(newTimeoutId);
    };

    const onLeadsFilterStatusChange = (value: string) => {
        const newFilter = leadsFilter;
        if (value !== '0') {
            newFilter.StatusIdSearch = value;
        } else {
            newFilter.StatusIdSearch = undefined;
        }
        setLeadsFilter(newFilter);
        getLeads(newFilter);
        // setTimeout(() => {
        //     getLeads(newFilter);
        // }, 1000);
    }

    const onPolicyFilterPolcyTypeChange = (value: string) => {
        const newFilter = leadsFilter;
        if (value !== '0') {
            newFilter.policyType = value;
        } else {
            newFilter.policyType = undefined;
        }
        setLeadsFilter(newFilter);
        getLeads(newFilter);
    }

    const clearLeadsFilter = () => {
        setLeadsSearchText('');
        const newFilter = {
            page: 1,
            customerId: props.customerId,
            StatusIdSearch: undefined,
            searchText: undefined,
            policyType: undefined
        };
        setLeadsFilter(newFilter);
        getLeads(newFilter);
    }
    // leads functions ends

    const nextPage = (page: number) => {
        const filter = {
            page: page,
            customerId: props.customerId
        }
        setPolicyFilter(filter);
        getPolicies(filter);
    }

    // const nextPage = (page: number) => {

    //     const newFilter = policiesPagerConf
    //     newFilter.currentPage = page;
    //     const filter = {
    //         page: page,
    //         customerId: props.customerId
    //     }
    //     setPolicyFilter(filter);
    //     getPolicies(filter);
    // }

    const onFirstPageClick = (page: number) => {
        const filter = {
            page: 1,
            customerId: props.customerId
        }
        setPolicyFilter(filter);
        getPolicies(filter);
    }


    // const onLastPageClick = (page: number) => {
    //     const filter = {
    //         page: page,
    //         customerId: props.customerId
    //     }
    //     setPolicyFilter(filter);
    //     getPolicies(filter);
    // }


    // policy functions
    const clearPolicyFilter = () => {
        setPolicySearchText('');
        const filter = {
            page: 1,
            customerId: props.customerId,
        }
        setPolicyFilter(filter);
        getPolicies(filter);
    }

    const getPolicies = async (filter?: any) => {
        if (!isRealGuid(props.customerId)) return; // unsaved customer has a temp (non-GUID) id — skip the server call
        props.setLoading(true);
        props.setLoading(true);
        if (!filter) {
            filter = policyFilter;
        }
        setPoliciesList([]);

        const policies: any[] = [];
        const policiesData: any = await leadsModel.policyFilter(filter);
        if (policiesData) {
            setAllRowsCounter(policiesData.allRowsCounter);
            console.log('getPolicies', policiesData);
            // const policyTypeItems = policiesData.subPolicies[0];
            if (filter.policyType != "elementary" && policiesData.riders && policiesData.riders.length > 0) {
                // const dataAll = buildRidersTree(policiesData.riders);
                // setRidersList(dataAll);
                const policyNumbers: any = {};
                policiesData.riders.forEach((item: any) => {
                    // item.policyType = policyTypeItems;
                    item.itemType = 'rider';
                    if (!policyNumbers[item.subscriberNumber]) {
                        policyNumbers[item.subscriberNumber] = [];
                    }
                    policyNumbers[item.subscriberNumber].push(item);
                })
                Object.keys(policyNumbers).forEach((pNumber: string) => {
                    policies.push(policyNumbers[pNumber]);
                })
            }
            if (filter.policyType != "riders" && policiesData.subPolicies && policiesData.subPolicies.length > 0) {
                // 
                let policyNum: any = {};
                let flag = false;
                policiesData.subPolicies.forEach((item: any) => {
                    item.itemType = 'policy';

                    // check if route is 80 or 74 and if it is already in the list
                    if (policyNum[item.policyNumber] && item.policyAdditionDetails && item.policyAdditionDetails.route
                        && item.policyAdditionDetails.route.routeId) {
                        // 
                        console.log('policyNum:>> ', policyNum);
                        console.log('policyNum[item.policyNumber] :>> ', policyNum[item.policyNumber]);
                        let founds = policyNum[item.policyNumber].filter((p: any) => p && p.policyAdditionDetails && p.policyAdditionDetails.route && p.policyAdditionDetails.route.routeId
                            && p.policyAdditionDetails.route.routeId == item.policyAdditionDetails.route.routeId
                            && p.policyAdditionDetails.vehiclePolicyType == item.policyAdditionDetails.vehiclePolicyType);

                        // let founds = policyNum[item.policyNumber].map((p: any) => {
                        //     
                        //     return p && p.policyAdditionDetails && p.policyAdditionDetails.route && p.policyAdditionDetails.route.routeId
                        //         && p.policyAdditionDetails.route.routeId == item.policyAdditionDetails.route.routeId &&
                        //         p.policyAdditionDetails.vehiclePolicyType == item.policyAdditionDetails.vehiclePolicyType})

                        if (founds.length > 0) {
                            flag = false;
                        } else if (policyNum[`${item.policyNumber}${item.policyAdditionDetails.route.routeId}${item.policyAdditionDetails.vehiclePolicyType}`]) {
                            policyNum[`${item.policyNumber}${item.policyAdditionDetails.route.routeId}${item.policyAdditionDetails.vehiclePolicyType}`].push(item);
                            flag = true;
                        } else {
                            policyNum[`${item.policyNumber}${item.policyAdditionDetails.route.routeId}${item.policyAdditionDetails.vehiclePolicyType}`] = [];
                            policyNum[`${item.policyNumber}${item.policyAdditionDetails.route.routeId}${item.policyAdditionDetails.vehiclePolicyType}`].push(item);
                            flag = true;
                        }
                        console.log('policyNum after push :>> ', policyNum);
                    }

                    if (!policyNum[item.policyNumber]) {
                        policyNum[item.policyNumber] = [];
                    }
                    if (!flag) {
                        policyNum[item.policyNumber].push(item);
                    }
                    flag = false;


                });
                console.log('policyNum :>> ', policyNum);
                Object.keys(policyNum).forEach((pNumber: string) => {
                    // console.log('policyNum[pNumber]',policyNum[pNumber]);
                    const newArrayOfPolices = [...policyNum[pNumber]].sort((a, b) =>a.additionNumber && b.additionNumber && a.additionNumber.localeCompare(b.additionNumber, undefined, { numeric: true }));                   
                    // console.log('policyNum newArrayOfPolices', newArrayOfPolices)
                    policies.push(newArrayOfPolices);
                })
            }
            policies.sort((a: any, b: any) => {
                // console.log('policiesData', moment(b[0].startDate).format('YYYY-DD-MM'), new Date(b.startDate).getTime(), moment(a[0].startDate).format('YYYY-DD-MM'),  new Date(a.startDate).getTime(), new Date(b.startDate).getTime() - new Date(a.startDate).getTime())
                return moment(b[0].startDate).diff(moment(a[0].startDate));
            })
            console.log('policyNum final policies', policies);


            // console.log('policies', policies);


            setPoliciesList([...policies]);
            if (policiesData.subPolicies && policiesData.subPolicies.length > 0) {
                const policyTypes: any[] = [];
                policyTypes.push({
                    label: 'כל הסוגים',
                    value: '-1'
                });
                policiesData.subPolicies.forEach((type: any) => {
                    policyTypes.push({
                        label: type.name,
                        value: type.id
                    })
                })
                setPolicyTypes(policyTypes);
                setPoliciesPagerConf({
                    pageSize: 50,
                    currentPage: 1,
                    totalItems: policyTypes.length
                })
            }
        }
        props.setLoading(false);
    }

   
    // policy functions end
    // documents
    const getDocuments = async (filter?: any) => {
        props.setLoading(true);
        if (!filter) {
            filter = documentsFilter;
        }
        setDocumentsList([]);
        const documentsData: any = await customerCardModel.customerDocumentsFilter(filter);
        if (documentsData && documentsData.length > 0) {
            // console.log('getDocuments', documentsData)
            const documents = documentsData.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());

            setDocumentsAllData(documents.length);
            setDocumentsList(documents);
        }
        props.setLoading(false);
    }

    const displayClientDocument = (documentUrl: string | null) => {
        if (props.config.displayClientDocument)
            props.config.displayClientDocument(documentUrl)
    }

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const showUploadDocument = () => {
        setShowModelUploadDocument({
            show: true,
            customerId: props.customerId
        });
    }

    const LoadNewDocuments = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const newFilter = documentsFilter;
        const fileUploaded = event.target.files ? event.target.files[0] : null;
        if (fileUploaded) {

            const base64 = await convertBase64(fileUploaded);
            const obj = {
                file: base64,
                name: fileUploaded.name,
                customerId: props.customerId
            }

            console.log('name', fileUploaded)
            console.log('name', fileUploaded.name)
            const response = await customerCardModel.customerDocumentsUploadFile(obj);
            if (response) {
                console.log('response', response)
                getDocuments(newFilter);
            }
        }

        // newFilter.page = e.selected + 1;
        // setDocumentsFilter(newFilter);
        // getDocuments(newFilter);

    }


    const handleDocumentsSearchChange = async (event: any) => {
        const newSearchText = event.target.value;
        setDocumentsSearchText(newSearchText);
        // console.log('handleSearchChange', leadsTimeoutId, newSearchText, event);
        const newFilter = documentsFilter;
        newFilter.searchTerm = newSearchText;
        setDocumentsFilter(newFilter);
        clearTimeout(documentsTimeoutId);
        const newTimeoutId = setTimeout(() => {
            getDocuments(newFilter);
        }, 1000);
        setDocumentsTimeoutId(newTimeoutId);
    };

    const onDocumentsDateChange = (d: Date, name: string) => {
        // setTreatmentsStartDate(d);
        const newFilter = documentsFilter;
        newFilter[name] = d;
        setDocumentsFilter(newFilter);
        getDocuments(newFilter);
    }

    const clearDocumentsFilter = () => {
        const filter: any = {
            page: 1,
            customerId: props.customerId,
            searchTerm: '',
            from: undefined,
            to: undefined
        }
        setDocumentsFilter(filter);
        getDocuments(filter)
    }

    const nextPageOnDocuments = (page: number) => {
        const filter = {
            page: page,
            customerId: props.customerId
        }
        const newFilter = documentsPagerConf;
        newFilter.pageSize = page
        setDocumentsPagerConf(newFilter);
        setDocumentsFilter(filter);
        getDocuments(filter);
    }

    const onFirstPageClickOnDocuments = (page: number) => {
        const filter = {
            page: 1,
            customerId: props.customerId
        }
        const newFilter = documentsPagerConf;
        newFilter.currentPage = 1
        setDocumentsPagerConf(newFilter);
        setDocumentsFilter(filter);
        getDocuments(filter);
    }

    // documents fumctions end

    // whatsApp
    const getWhatsAppMessages = async (filter?: any) => {
        if (!isRealGuid(props.customerId)) return; // unsaved customer has a temp (non-GUID) id — skip the server call
        if (!filter) {
            filter = whatsAppFilter;
        }
        const whatsAppData = await whatsAppModel.whatsappIndex(filter);
        if (whatsAppData && whatsAppData.messages) {
            setWhatsAppItemsList(whatsAppData.messages);
        }
    }
    const gotoWhatsApp = async () => {
        await localStorage.setItem('selectedWhatsApCustomer', props.customerId);
        navigate('/Whatsapp');
    }
    // whatsApp end

    const turnEditMode = async (mode: ViewMode = ViewMode.EDIT) => {
        console.log('turnEditMode');
        props.setLoading(true);
        if (mode == ViewMode.EDIT) {
            let customerData: CustomerModel = new CustomerModel();

            console.log('turnEditMode', props.tabData);

            if (props.tabData.editData) {
                customerData = props.tabData.editData;
            } else {
                customerData = await customerCardModel.getEditPersonalData(props.customerId);
            }
            const personalData = props.tabData.personalData;
            if (customerData) {
                if (customerData.identityIssueDate) {
                    if (moment(customerData.identityIssueDate).isValid() && moment(customerData.identityIssueDate).format('YYYY-MM-DD') !== '0001-01-01') {
                        setIdentityIssueDate(customerData.identityIssueDate);
                    } else {
                        setIdentityIssueDate(null)
                    }
                } else {
                    setIdentityIssueDate(null)
                }
                if (customerData.dateOfBirth) {
                    // moment(v.entryToRoadDate).isValid() && moment(v.entryToRoadDate).isAfter('1900-01-2401T00:00:00Z')
                    if (moment(customerData.dateOfBirth).isValid() && moment(customerData.dateOfBirth).format('YYYY-MM-DD') !== '0001-01-01') {
                        setDateOfBirth(customerData.dateOfBirth);
                    } else {
                        setDateOfBirth(null)
                        setCustomerAge('');
                    }
                } else {
                    setDateOfBirth(null)
                }
                if (customerData.driverLicensIssueDate) {

                    setDriverLicensIssueDate(customerData.driverLicensIssueDate)
                }
                if (personalData.customerData.customerAddresses.length > 0 && (!customerData.customerAddresses || customerData.customerAddresses.length == 0)) {
                    customerData.customerAddresses = [...personalData.customerData.customerAddresses];
                }
                if (personalData.customerData.customerContactDetails.length > 0 && (!customerData.customerContactDetails || customerData.customerContactDetails.length == 0)) {
                    customerData.customerContactDetails = [...personalData.customerData.customerContactDetails];
                } else {
                }
                setDataForEdit(new CustomerModel(customerData));
                setMode(mode);

                console.log('turnEditMode', dataForEdit.gender, typeof (dataForEdit.gender), props.config.genders)
                // props.updateEditData(props.customerId, customerData);
            }
        } else {
            const data: CustomerModel = props.tabData.editData ? props.tabData.editData : props.tabData.personalData.customerData;
            if (!data.customerContactDetails) {
                data.customerContactDetails = [];
            }
            if (data.customerContactDetails.length == 0) {
                const newContact: CustomerContactDetailsModel = new CustomerContactDetailsModel();
                // newContact.hasError = true;
                data.customerContactDetails.push(newContact);
            }
            if (!data.customerAddresses) {
                data.customerAddresses = [];
            }
            if (data.customerAddresses.length == 0) {
                const newAddress: CustomerAddress = new CustomerAddress();
                // newAddress.hasError = true;
                data.customerAddresses.push(newAddress);
            }
            // dataForEdit.identityType ? dataForEdit.identityType : IdentityType._1
            data.identityType = data.identityType == 0 ? IdentityType._1 : data.identityType;
            setIsPerson(true);
            data.createdDate = undefined;
            data.dateOfBirth = undefined;
            data.identityIssueDate = undefined;
            data.updatedDate = undefined;
            // const customerData = new CustomerModel({
            //     id: data.id
            // });
            setDataForEdit(data);
            updateMode(mode)
        }
        props.setLoading(false);
    }

    const turnViewMode = () => {
        const data = dataForEdit;
        data.note += '';
        setMode(ViewMode.VIEW);
        // props.updateEditData(props.customerId, dataForEdit, ViewMode.VIEW);
        updateMode(ViewMode.VIEW)
    }

    const updateEditData = () => {
        props.updateEditData(props.customerId, dataForEdit, mode);
    }

    const updateMode = (mode: ViewMode) => {
        props.updateMode(props.customerId, mode)
        setMode(mode);
    }

    const selectTab = (tabName: string) => {
        setTab(tabName);
        switch (tabName) {
            case 'Documents':
                console.log(personalData.customerDocumentsTab);
                if (documentsList.length == 0) {
                    getDocuments();
                }
                break;
            case 'Treatment':
                console.log(personalData.customerDocumentsTab);
                if (treatmentsList.length == 0) {
                    getTreatments();
                }
                break;
            case 'Polices':
                if (policiesList.length == 0) {
                    getPolicies();
                }
                break;
            case 'Suggestions':
                if (leadsList.length == 0) {
                    getLeads();
                }
                if (leadStatuses.length == 0) {
                    getLeadStatuses();
                }
                break;
            case 'WhatsApp':
                if (whatsAppItemsList.length == 0) {
                    getWhatsAppMessages();
                }
                // if (leadStatuses.length==0) {

                // }
                break;
            case 'Calls':
                if (speakComItems.length == 0) {
                    getSpeakComItems();
                }

                break;
            default:
                break;
        }
    }


    const calcCustomerAge = (date: Date) => {
        let age: number = 0;
        const today: moment.Moment = moment();
        const birthdate: moment.Moment = moment(date);
        age = today.diff(birthdate, 'years');
        setCustomerAge(age.toString());
        console.log('customerAge change func:', age, date);
        // console.log(customerAge);
        return age;
    }

    const getUpdatedCustomerAge = () => {
        let age: number = 0;
        if (dataForEdit && dataForEdit.dateOfBirth && moment(dataForEdit.dateOfBirth).format('YYYY-MM-DD') !== '0001-01-01') {
            const today: moment.Moment = moment();
            const birthdate: moment.Moment = moment(dataForEdit.dateOfBirth);
            age = today.diff(birthdate, 'years');
        }
        return age > 0 ? age : '';
    }


    const setGender = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('setGender', value, option);
        (dataForEdit.gender as any) = value;
        setDataForEdit(new CustomerModel(dataForEdit));
    }

    const setMartialStatus = (value: string, option: { label: string; value: string; } | { label: string; value: string; }[] | undefined) => {
        console.log('setMartialStatus', value, option);
        (dataForEdit.maritalStatus as any) = value;
        setDataForEdit(new CustomerModel(dataForEdit));
    }

    const onDateChange = async (name: string, date: Date) => {
        console.log('onDateChange', date);
        switch (name) {
            case 'identityIssueDate':
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    dataForEdit.identityIssueDate = date;
                    setIdentityIssueDate(date);
                } else {
                    dataForEdit.identityIssueDate = undefined;
                    setIdentityIssueDate(null);
                }
                break;
            case 'dateOfBirth':
                console.log('dateOfBirth-date', date, moment(date).isValid(), moment(date).format('YYYY-MM-DD') !== '0001-01-01');
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setDateOfBirth(date);
                    dataForEdit.dateOfBirth = date;
                } else {
                    dataForEdit.dateOfBirth = undefined;
                    setDateOfBirth(null)
                }
                break;
            case 'driverLicensIssueDate':
                dataForEdit.driverLicensIssueDate = date;
                setDriverLicensIssueDate(date);
                break;
            default:
                break;
        }
        setDataForEdit(dataForEdit);
    }
    const removeNonHebrewCharacters = (input: string): string => {
        return input.replace(/[^\u0590-\u05FF\s'"-]/g, '');
        // const regex =     /[^\u0590-\u05FF\s.,]/g;
    }

    const validateIsraelPhoneNumber = (phoneNumber: string): boolean => {
        if(phoneNumber.length === 9 && (phoneNumber.startsWith('05') || phoneNumber.startsWith('07') || phoneNumber.startsWith('01'))){
            return false;
        }
        // Regular expression for Israel phone numbers
        const israelPhoneNumberRegex = /^(0\d{1,2})-?(\d{3})-?(\d{4})$/;
        // Remove any non-digit characters from the phone number
        const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
        // Check if the cleaned phone number matches the Israel phone number regex
        return israelPhoneNumberRegex.test(cleanedPhoneNumber);
    }

    const onParamChange = async (name: string, value: string) => {
        const data: any = dataForEdit as any;
        const errors: dataErrors = clientDataErrors;
        // data[name] = '';
        // await setDataForEdit(new CustomerModel(data));
        switch (name) {
            case 'identifier':
                value = value.replace(/[^0-9]/g, '');
                data[name] = value;
                break;

            case 'firstName': {
                value = removeNonHebrewCharacters(value);
                if (value == '') {
                    errors.firstName = true;
                } else {
                    value = removeNonHebrewCharacters(value);
                    errors.firstName = false;
                }
                data[name] = value;
                break
            }
            case 'lastName': {
                value = removeNonHebrewCharacters(value);
                if (value == '') {
                    errors.lastName = true;
                } else {
                    errors.lastName = false;
                }
                data[name] = value;
                break
            }
            case 'companyName': {
                if (value == '') {
                    errors.firstName = true;
                } else {
                    errors.firstName = false;
                }
                data['firstName'] = value;
                break
            }
            case 'workplace': {
                value = removeNonHebrewCharacters(value);
                if (value == '') {
                    errors.workplace = true;
                } else {
                    value = removeNonHebrewCharacters(value);
                    errors.workplace = false;
                }
                data[name] = value;
                break
            }
            case 'driverLicenseNumber':
                value = value.replace(/\D/g, '');
                data[name] = value;
                break;

            default:
                data[name] = value;
                break;
        }
        // console.log('setDataForEdit', name, value, data)
        await setDataForEdit(new CustomerModel(data));
        // console.log('onParamChange', name, value);
    }

    const onInputBlur = async (name: string, value: string) => {
        const data: any = dataForEdit as any;
        const errors: dataErrors = clientDataErrors;
        if (value && value != '') {
            switch (name) {
                case 'identifier':
                    value = value.trim();
                    if (checkIdentity(value) && mode != ViewMode.EDIT) {
                        const customerDetails: any = await simulatorModel.getCustomerDetailsById(value);
                        if (customerDetails && customerDetails.customer) {
                            errors.identifier = true;
                            errors.identifierMessage = "לקוח קיים במערכת, שונו פרטי לקוח";
                            setClientDataErrors(errors)
                        }
                    }
                    // data[name] = value;
                    break;

                // case 'firstName': {
                //     if (value == '') {
                //         errors.firstName = true;
                //     } else {
                //         errors.firstName = false;
                //     }
                //     data[name] = value;
                //     break
                // }
                // case 'lastName': {
                //     if (value == '') {
                //         errors.lastName = true;
                //     } else {
                //         errors.lastName = false;
                //     }
                //     data[name] = value;
                //     break
                // }
                default:
                    // data[name] = value;
                    break;
            }
        }
        await setDataForEdit(new CustomerModel(data));
        //console.log('onParamChange', name, value);
    }
    const onInputFocus = async (name: string, value: string) => {
        const data: any = dataForEdit as any;
        const errors: dataErrors = clientDataErrors;
        switch (name) {
            case 'identifier':
                errors.identifier = false
                setClientDataErrors(errors);
                break;
            default:
                // data[name] = value;
                break;
        }
        await setDataForEdit(new CustomerModel(data));
        //console.log('onParamChange', name, value);
    }

    const addNewAddress = async () => {
        const newAddress = new CustomerAddressModel();
        const addresses: CustomerAddressModel[] = dataForEdit.customerAddresses ? dataForEdit.customerAddresses : [];
        addresses.push(newAddress);
        dataForEdit.customerAddresses = [...addresses];
        await setDataForEdit(new CustomerModel(dataForEdit));
    }

    const onAddressChange = async (address: CustomerAddressModel, index: number) => {
        const data: CustomerModel = dataForEdit;
        if (data.customerAddresses) {
            data.customerAddresses[index] = address;
            setDataForEdit(new CustomerModel(dataForEdit));
            //console.log('onAddressChange', address, dataForEdit.customerAddresses);
        }
    }

    const onAddressDelete = async (index: number) => {
        // const data = cloneDeep(dataForEdit);
        // if (data.customerAddresses) {
        //     console.log('data.customerAddresses index', index)
        //     console.log('data.customerAddresses after splice before', data.customerAddresses);
        //     let addressAfterDelete = data.customerAddresses.filter((addr: any, indexAdre: number) => (indexAdre !== index));
        //     // data.customerAddresses.splice(index, 1);
        //     console.log('data.customerAddresses after splice', addressAfterDelete);
        //     data.customerAddresses = [];
        //     data.customerAddresses = [...addressAfterDelete];
        //     setDataForEdit(new CustomerModel(data));
        //     //console.log('onAddressDelete', address, data.customerAddresses);
        //     // if (address.id) {
        //     //     const data: Input = new Input({
        //     //         id: address.id.toString()
        //     //     });
        //     //     await customerCardModel.deleteCustomerAddressDetails(data)
        //     // }
        // }
        setDataForEdit(prev => {
            if (!prev.customerAddresses) return prev;

            const next = cloneDeep(prev); // or new CustomerModel(prev)
            next.customerAddresses = prev.customerAddresses.filter((_, i) => i !== index);
            return new CustomerModel(next);
        });
    }

    const addNewContact = async () => {
        const newContact = new CustomerContactDetailsModel();
        const contacts: CustomerContactDetailsModel[] = dataForEdit.customerContactDetails ? dataForEdit.customerContactDetails : [];
        contacts.push(newContact);
        dataForEdit.customerContactDetails = contacts;
        await setDataForEdit(new CustomerModel(dataForEdit));
    }

    const onContactChange = (contact: CustomerContactDetailsModel, index: number) => {
        //console.log('onContactChange', contact);
        const data: CustomerModel = dataForEdit;
        if (data.customerContactDetails) {
            data.customerContactDetails[index] = contact;
            setDataForEdit(new CustomerModel(dataForEdit));
            // //console.log('onContactChange', contact, data.customerContactDetails);
        }
    }

    const onContactDelete = (address: CustomerContactDetailsModel, index: number) => {
        const data: CustomerModel = dataForEdit;
        if (data.customerContactDetails && data.customerContactDetails.length > 1) {
            data.customerContactDetails.splice(index, 1);
            setDataForEdit(new CustomerModel(dataForEdit));
            //console.log('onContactDelete', address, data.customerContactDetails);
        }
    }
    // Validations

    const isValidIsraeliId = (id: string): boolean => {
        // Check if the input is a string and has 9 digits
        if (!/^\d{9}$/.test(id)) return false;

        // Convert the ID number to an array of digits
        const digits = id.split('').map(Number);

        // Calculate the sum of the digits
        let sum = 0;
        for (let i = 0; i < 8; i++) {
            let digit = digits[i];
            if (i % 2 === 0) {
                // For even indices, multiply the digit by 1
                sum += digit;
            } else {
                // For odd indices, multiply the digit by 2 and add the digits of the result
                sum += Math.floor(digit * 2 / 10) + (digit * 2) % 10;
            }
        }

        // The ninth digit (check digit)
        const checkDigit = digits[8];

        // Validate the check digit
        return (sum + checkDigit) % 10 === 0;
    }

    const clearIdentityError = () => {
        const errors: dataErrors = clientDataErrors;
        errors.identifier = false;
        errors.identifierMessage = '';
        setClientDataErrors(errors)
    }

    const checkIdentity = (id: string): boolean => {
        clearIdentityError();
        const errors: dataErrors = clientDataErrors;
        const identityType: IdentityType = dataForEdit.identityType ? dataForEdit.identityType : IdentityType._1;
        if (!id) {
            errors.identifier = true;
            errors.identifierMessage = "שדה חובה";
            return false;
        }
        if (identityType == IdentityType._1 && !isValidIsraeliId(id)) {
            errors.identifier = true;
            if (id) {
                if (id.length != 9) {
                    errors.identifierMessage = "כמות ספרות לא חוקית";
                } else {
                    errors.identifierMessage = "מס' זהות לא תקין";
                }
            } else {
                errors.identifierMessage = "שדה חובה";
            }
            setClientDataErrors(errors)
            //console.log('checkIdentity', clientDataErrors)
            return false;
        } else {
            if (identityType == IdentityType._3) {
                if (id && id.length != 9 || !/^\d{9}$/.test(id)) {
                    errors.identifier = true;
                    errors.identifierMessage = "כמות ספרות לא חוקית";
                    setClientDataErrors(errors)
                    //console.log('checkIdentity', clientDataErrors)
                    return false;
                }
            }
        }
        return true;
    }
    // Validations END

    const save = async () => {
        // savePersonalData
        let hasError: boolean = false;
        console.log('mode:', mode);
        const isAddMode = mode == ViewMode.ADD;

        console.log('isAddMode', isAddMode)

        const identifier: string = dataForEdit.identifier;
        const identityType: IdentityType = dataForEdit.identityType ? dataForEdit.identityType : IdentityType._1;
        if (!checkIdentity(identifier)) {
            hasError = true;
            const d = dataForEdit
            d.identifier = dataForEdit.identifier;
            setDataForEdit(new CustomerModel(d));
            console.log('clientDataErrors', clientDataErrors);
        } else {
            if (mode != ViewMode.EDIT) {
                const customerDetails: any = await simulatorModel.getCustomerDetailsById(identifier);
                if (customerDetails && customerDetails.customer) {
                    hasError = true;
                    clientDataErrors.identifier = true;
                    clientDataErrors.identifierMessage = "לקוח קיים במערכת, שונו פרטי לקוח";
                    setClientDataErrors(clientDataErrors)
                }
            }
        }
        if (dataForEdit.customerContactDetails && dataForEdit.customerContactDetails.length > 0) {
            dataForEdit.customerContactDetails.forEach((contact: CustomerContactDetailsModel, index: number) => {
                // contact.hasError = false;
                if (contact.hasError) {
                    hasError = true;
                }
                if (!contact.title || contact.title == '') {
                    hasError = true;
                    contact.hasError = true
                }
                let phoneNumber = contact.number ? contact.number.trim() : '';
                console.log('contact.number', phoneNumber.length, phoneNumber, validateIsraelPhoneNumber(phoneNumber))
                if (index == 0 && (!phoneNumber || phoneNumber == '')) {
                    console.log("contact.number 'phoneNumber == '' or undifind", "")
                    hasError = true;
                    contact.hasError = true
                }
                if ((phoneNumber && phoneNumber.trim().length < 9) || (phoneNumber && validateIsraelPhoneNumber(phoneNumber) == false)) {
                    console.log("contact.number 'phoneNumber < 9 '' or validateIsraelPhoneNumber == false", "")
                    hasError = true;
                    contact.hasError = true
                } else {
                    console.log('contact.number valid', phoneNumber)
                }

            })
        }

        if (dataForEdit.customerAddresses && dataForEdit.customerAddresses.length > 0) {
            dataForEdit.customerAddresses.forEach((address: CustomerAddress) => {
                // contact.hasError = false;
                // 
                console.log('save address', address)
                // if (address.hasError) {
                //     hasError = true;
                // }
                if (!address.city || address.city == '') {
                    hasError = true;
                    address.hasError = true
                } else
                    if ((!address.street || address.street == '') && (!address.mailbox || address.mailbox == '')) {
                        hasError = true;
                        address.hasError = true
                    } else if ((!address.mailbox || address.mailbox === '') && ((!address.houseNumber || address.houseNumber == 0) || (typeof address.houseNumber === "string" && address.houseNumber === ""))) {
                        console.log('typeof address.houseNumber', typeof address.houseNumber)
                        hasError = true;
                        address.hasError = true
                    } else {
                        address.hasError = false;
                    }

                if (!address.addressType) {
                    address.addressType = "0";
                } else {
                    address.addressType = address.addressType
                }

            })
        }

        let errors: dataErrors = clientDataErrors;
        if (dataForEdit.identityType !== IdentityType._3) {
            if (!dataForEdit.firstName || dataForEdit.firstName == '') {
                hasError = true;
                errors.firstName = true;
            } else {
                errors.firstName = false;
            }
            if (!dataForEdit.lastName || dataForEdit.lastName == '') {
                hasError = true;
                errors.lastName = true;
            } else {
                errors.lastName = false;
            }
        } else {
            dataForEdit.dateOfBirth = undefined;
            if (!dataForEdit.firstName || dataForEdit.firstName == '') {
                hasError = true;
                errors.firstName = true;
            } else {
                dataForEdit.firstName = dataForEdit.firstName;
                errors.firstName = false;
            }
        }
        console.log('clientDataErrors', errors)
        console.log('hasError', hasError)
        setClientDataErrors(errors);

        if (hasError) {
            const d = dataForEdit
            d.identifier = dataForEdit.identifier;
            d.firstName = dataForEdit.firstName;
            d.lastName = dataForEdit.lastName;
            setDataForEdit(new CustomerModel(d));
            return;
        }

        const d = dataForEdit;
        if (!d.identityIssueDate || moment(d.identityIssueDate).format('YYYY-MM-DD') == '0001-01-01') {
            d.identityIssueDate = undefined;
        }
        if (!isAddMode) {
            if (d.vehicles) {
                d.vehicles.forEach((v: any) => {
                    if (moment(v.entryToRoadDate).isValid() && moment(v.entryToRoadDate).isAfter('1900-01-2401T00:00:00Z')) {
                    } else {
                        v.entryToRoadDate = undefined
                    }
                })
                setDataForEdit(new CustomerModel(d));
                props.updateEditData(props.customerId, d);
            }
            console.log('save', dataForEdit);
            setLoadingSave(true);
            customerCardModel.savePersonalData(d).then((res: any) => {
                setLoadingSave(false);

                console.log(res);
                setPersonalData(new CustomerModel(d));
                if (props.setMessege && props.setPopupShow) {
                    props.setMessege("פרטי לקוח עודכנו בהצלחה");
                    props.setPopupShow(true);
                }
            }).finally(() => {
                if (props.config.refresh) {
                    props.config.refresh();
                }
                turnViewMode();
            })
        } else {
            setLoadingSave(true);
            console.log('d', d)
            customerCardModel.savePersonalData(d).then((res: any) => {
                console.log('save new customer', res);
                setLoadingSave(false);
                d.id = res;
                setDataForEdit(new CustomerModel(d));
                props.updateEditData(d.id, d);
                if (props.setMessege && props.setPopupShow) {
                    props.setMessege("לקוח נוצר בהצלחה");
                    props.setPopupShow(true);
                }
                if (props.config.closeTab) {
                    props.config.closeTab(d.id);
                }
                if (props.onRowSelect) {

                    props.onRowSelect(res);
                }
            }).finally(() => {
                // if (props.config.refresh) {
                //     props.config.refresh();
                // }
                // setTimeout(()=>{
                //     if(props.config.closeTab) {
                //         props.config.closeTab(d.id);
                //     }
                // }, 1000);
            })

            // turnViewMode();
        }
    }

    const toggleDetailsType = (newType: IdentityType) => {
        const currType = newType == IdentityType._1;
        const data: CustomerModel = dataForEdit;
        if (currType) {
            data.identityType = IdentityType._1
            // identityType == IdentityType._1
        } else {
            data.identityType = IdentityType._3
        }
        console.log('toggleDetailsType', data.identityType);
        setDataForEdit(new CustomerModel(data));
        setIsPerson(currType);
    }


    useEffect(() => {
        console.log('ClientDetails init');
        if (props.tabData) {
            if (props.tabData.personalData) {
                setPersonalData(props.tabData.personalData);
                // moment(v.entryToRoadDate).isValid() && moment(v.entryToRoadDate).isAfter('1900-01-2401T00:00:00Z')
                const date = props.tabData.personalData.customerData.dateOfBirth;
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setDateOfBirth(date);
                    const age: number = calcCustomerAge(date);
                    setCustomerAge(age.toString());
                    console.log('customerAge change func:', age);
                } else {
                    setDateOfBirth(null);
                    setCustomerAge('');
                }
                setIsPerson(props.tabData.personalData.customerData.identityType == IdentityType._1);
                const identityIssueDate = props.tabData.personalData.customerData.identityIssueDate;
                if (moment(identityIssueDate).isValid() && moment(identityIssueDate).format('YYYY-MM-DD') !== '0001-01-01') {
                    setIdentityIssueDate(identityIssueDate);
                } else {
                    setIdentityIssueDate(null);
                }
            }
            getLeadStatuses();
        }
        if (props.config && props.config.martialStatuses) {
            const mStatuses: any[] = [];
            props.config.martialStatuses.forEach((s: any) => {
                mStatuses.push({
                    label: s.label,
                    value: `${s.value}`
                })
            });
            setMartialStatuses(mStatuses);
            console.log('component start', props.config.genders)
        }
        if (props.config && props.config.genders) {
            const mGenders: any[] = [];
            props.config.genders.forEach((s: any) => {
                mGenders.push({
                    label: s.label,
                    value: `${s.value}`
                })
            });
            setGenders(mGenders);
            console.log('component start', props.config.genders)
        }
        // calcCustomerAge(dateOfBirth)
        init();
    }, [])

    useEffect(() => {
        console.log('ClientDetails props changed');
        if (props.tabData) {
            if (props.tabData.personalData) {
                setPersonalData(props.tabData.personalData);
                // props.tabData.personalData.customerData.dateOfBirth
            }
            // getTreatments();
            if (props.tabData.offerTab) {
                const offers: OfferModel[] = [];
                props.tabData.offerTab.items.forEach((item: any) => {
                    if (item.items) {
                        item.items.forEach((i: any) => {
                            offers.push(i);
                        })
                    }
                })
                setOffersList(offers);
            }
            if (props.tabData.customerSueTab) {
                const sues: SueModel[] = [];
                props.tabData.customerSueTab.items.forEach((item: any) => {
                    if (item.items) {
                        item.items.forEach((i: any) => {
                            sues.push(i);
                        })
                    }
                })
                setSuesList(sues);
            }
            if (props.tabData.customerWhatsappTab) {
                const whatsUps: CustomerWhatsappModelItem[] = [];
                props.tabData.customerWhatsappTab.items.forEach((item: any) => {
                    if (item.items) {
                        item.items.forEach((i: any) => {
                            whatsUps.push(i);
                        })
                    }
                })
                setWhatsAppList(whatsUps);
            }

            if (props.tabData.mode == ViewMode.EDIT) {
                // turnEditMode();
            }
        }
    }, [props]);

    // useEffect(() => {
    //     console.log(dataForEdit)
    // }, [dataForEdit]);

    useEffect(() => {
        console.log('ClientDetails props[mode] changed');
        switch (props.tabData.mode) {
            case ViewMode.ADD:
                turnEditMode(ViewMode.ADD);
                break;
            case ViewMode.EDIT:
                turnEditMode(ViewMode.EDIT);
                break;

            default:
                turnViewMode();
                break;
        }
        // if (props.tabData.mode == ViewMode.EDIT) {
        // } else {
        // }
    }, [props.tabData.mode])

    useEffect(() => {
        if (dateOfBirth) {
            calcCustomerAge(dateOfBirth)
        }
    }, [dateOfBirth])

    // useEffect(() => {
    //     updateEditData();
    // }, [dataForEdit])

    // useEffect(() => {
    //     // updateMode();
    //     console.log('customerAge change:', customerAge)
    // }, [customerAge])

    const onAddOfferOptionClick = (type: number) => {
        if (props.config.showAddTreatmentPopup) {
            props.config.showAddTreatmentPopup(type);
            // console.log('onAddOfferOptionClick')
            // switch (type) {
            //     case TreatmentType._3: // Email
            //         let userDetails = `שם: ${dataForEdit.fullName}, ת"ז: ${dataForEdit.identifier}`;
            //         console.log('onAddOfferOptionClick userDetails',type, userDetails)
            //         dispatch(setEmailSubjectDetails(userDetails));
            //         props.config.showAddTreatmentPopup(type);
            //         break;          
            //     default:
            //         props.config.showAddTreatmentPopup(type);
            //         break;
            // }
        }
    }

    const showPopUpTreatment = (type: number) => {
        if (props.config.showAddTreatmentPopup) {
            console.log('onAddOfferOptionClick')
            switch (type) {
                case TreatmentType._3: // Email
                    let userDetails = `שם: ${dataForEdit.fullName}, ת"ז: ${dataForEdit.identifier}`;
                    console.log('onAddOfferOptionClick userDetails', type, userDetails)
                    dispatch(setEmailSubjectDetails(userDetails));
                    dispatch(setTypeTreatmentsAction("new"));
                    props.config.showAddTreatmentPopup(type);
                    break;
                case TreatmentType._4: // Documentation
                    let userDetails8 = `שם: ${dataForEdit.fullName}, ת"ז: ${dataForEdit.identifier}`;
                    console.log('onAddOfferOptionClick userDetails', type, userDetails8)
                    dispatch(setEmailSubjectDetails(userDetails8));
                    props.config.showAddTreatmentPopup(type);
                    break;
                default:
                    props.config.showAddTreatmentPopup(type);
                    break;
            }
        }
    }


    function showTreatmentConfigPopup() {
        if (props.config.showTreatmentConfigPopup) {
            props.config.showTreatmentConfigPopup()
        }
        // setShowTreatmentConfigPopup(true)
    }


    return (
        <div className="content-body client-details client-details-view">


            <div className="clients-tabs-client-card-tabs client-details-view">
                <div className={`client-card-tab pointer ${tab == 'CustomerCard' ? 'selected' : ''}`} onClick={() => selectTab('CustomerCard')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        כרטיס לקוח
                    </div>
                    <div className="under-line"></div>
                </div>
                <div className={`client-card-tab pointer ${tab == 'Treatment' ? 'selected' : ''}`} onClick={() => selectTab('Treatment')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        טיפול שוטף
                    </div>
                    <div className="under-line"></div>
                </div>
                <div className={`client-card-tab pointer ${tab == 'Polices' ? 'selected' : ''}`} onClick={() => selectTab('Polices')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        פוליסות ותוכניות
                    </div>
                    <div className="under-line"></div>
                </div>
                <div className={`client-card-tab pointer ${tab == 'Suggestions' ? 'selected' : ''}`} onClick={() => selectTab('Suggestions')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        הצעות
                    </div>
                    <div className="under-line"></div>
                </div>
                <div className={`client-card-tab pointer ${tab == 'Problems' ? 'selected' : ''}`} onClick={() => selectTab('Problems')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        תביעות
                    </div>
                    <div className="under-line"></div>
                </div>
                <div className={`client-card-tab pointer ${tab == 'Documents' ? 'selected' : ''}`} onClick={() => selectTab('Documents')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        מסמכים
                    </div>
                    <div className="under-line"></div>
                </div>
                <div className={`client-card-tab pointer ${tab == 'WhatsApp' ? 'selected' : ''}`} onClick={() => selectTab('WhatsApp')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        וואטס אפ
                    </div>
                    <div className="under-line"></div>
                </div>
                <div className={`client-card-tab pointer ${tab == 'Calls' ? 'selected' : ''}`} onClick={() => selectTab('Calls')}>
                    <div className="label" style={{fontWeight: 'bold'}}>
                        שיחות
                    </div>
                    <div className="under-line"></div>
                </div>
            </div>
            <div className={`client-tab-content client-details-edit-mode ${tab == 'CustomerCard' && mode != ViewMode.VIEW ? '' : 'hide'}`}>
                <div className="right-side">
                    <div className='inner vert-scrolling'>
                        <div className="client-tab-content-block client-details personal-details">
                            <div className="tab-content-title">
                                פרטים אישיים
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            &nbsp;
                                        </div>
                                        <div className="value toggle">
                                            <input type="radio" className="toggle-input client-type client-type-personal" id="private01" name="client_type01" value="private" data-type="personal" checked={dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1} />
                                            <label onClick={() => toggleDetailsType(IdentityType._1)}>
                                                לקוח פרטי
                                            </label>
                                            <input type="radio" className="toggle-input client-type client-type-company" id="company01" name="client_type01" value="company" data-type="company" checked={dataForEdit.identityType == IdentityType._3} />
                                            <label onClick={() => toggleDetailsType(IdentityType._3)}>
                                                חברה
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`parameter-item ${clientDataErrors && clientDataErrors.identifier ? 'error' : 'no-error'}`}>
                                    <div className="field">
                                        <div className="title">
                                            {dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? (<>
                                                ת.ז.
                                            </>) : (<>
                                            </>)}
                                            {dataForEdit.identityType == IdentityType._3 ? (<>
                                                ח.פ.
                                            </>) : (<>
                                            </>)}
                                        </div>
                                        <div className="value">
                                            <input type="text" value={dataForEdit.identifier} onChange={(e: any) => onParamChange('identifier', e.target.value)} onBlur={() => onInputBlur('identifier', dataForEdit.identifier)} onFocus={() => onInputFocus('identifier', dataForEdit.identifier)} />
                                        </div>
                                        <div className='error-message'>
                                            *{clientDataErrors.identifierMessage}
                                        </div>
                                    </div>
                                </div>
                                {dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? (<>
                                    <div className={`parameter-item ${clientDataErrors && clientDataErrors.firstName ? 'error' : 'no-error'}`}>
                                        <div className="field">
                                            <div className="title">
                                                שם פרטי
                                            </div>
                                            <div className="value">
                                                <input type="text" value={dataForEdit.firstName} onChange={(e: any) => onParamChange('firstName', e.target.value)} />
                                            </div>
                                            <div className='error-message'>
                                                *שדה חובה
                                            </div>
                                        </div>
                                    </div>
                                </>) : (<>
                                </>)}

                                {dataForEdit.identityType == IdentityType._3 ? (<>
                                    <div className={`parameter-item ${clientDataErrors && clientDataErrors.firstName ? 'error' : 'no-error'}`}>
                                        <div className="field">
                                            <div className="title">
                                                שם עסק
                                            </div>
                                            <div className="value">
                                                <input type="text" value={dataForEdit.firstName} onChange={(e: any) => onParamChange('companyName', e.target.value)} />
                                            </div>
                                            <div className='error-message'>
                                                *שדה חובה
                                            </div>
                                        </div>
                                    </div>
                                </>) : (<>
                                </>)}

                                <div className={`parameter-item ${clientDataErrors && clientDataErrors.lastName ? 'error' : 'no-error'} ${dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? '' : 'hide'}`}>
                                    <div className="field">
                                        <div className="title">
                                            שם משפחה
                                        </div>
                                        <div className="value">
                                            <input type="text" value={dataForEdit.lastName} onChange={(e: any) => onParamChange('lastName', e.target.value)} />
                                        </div>
                                        <div className='error-message'>
                                            *שדה חובה
                                        </div>
                                    </div>
                                </div>
                                <div className={`parameter-item ${dataForEdit.identityType == IdentityType._3 ? '' : 'hide'}`}>
                                    <div className="field">
                                        <div className="title">
                                            תחום העסק
                                        </div>
                                        <div className="value">
                                            <input type="text" value={dataForEdit.businessTitle} onChange={(e: any) => onParamChange('businessTitle', e.target.value)} />
                                        </div>
                                        {/* <div className='error-message'>
                                            *שדה חובה
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-row ${dataForEdit.identityType == IdentityType._0 || dataForEdit.identityType == IdentityType._1 ? '' : 'hide'}`}>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מגדר
                                        </div>
                                        <div className="value">
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="מגדר"
                                                value={dataForEdit && dataForEdit.gender ? dataForEdit.gender.toString() : props.config.genders[0].value.toString()}
                                                onChange={setGender}
                                                options={
                                                    props.config.genders
                                                }
                                            />

                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            תאריך הנפקת ת.ז.
                                        </div>
                                        <div className="value">
                                            <CompDatePicker value={identityIssueDate} onChange={(date: Date) => onDateChange('identityIssueDate', date)} />

                                        </div>

                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            תאריך לידה
                                        </div>
                                        <div className="value">
                                            <CompDatePicker value={dateOfBirth} onChange={(date: Date) => onDateChange('dateOfBirth', date)} />

                                        </div>
                                    </div>
                                    <div className="field">
                                        <div className="title">
                                            גיל
                                        </div>
                                        <div className="value grey-text-age">
                                            {getUpdatedCustomerAge()}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מצב משפחתי
                                        </div>
                                        <div className="value" title={`maritalStatus is ${dataForEdit.maritalStatus ? dataForEdit.maritalStatus.toString() : 'NONE'}`}>
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="מצב משפחתי"
                                                // defaultValue={dataForEdit && dataForEdit.maritalStatus ? dataForEdit.maritalStatus.toString() : props.config.martialStatuses[0]}
                                                value={dataForEdit && dataForEdit.maritalStatus ? dataForEdit.maritalStatus.toString() : props.config.martialStatuses[0].value}
                                                onChange={setMartialStatus}
                                                options={
                                                    martialStatuses
                                                }
                                            />

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className={`parameter-row ${dataForEdit.identityType == IdentityType._3 ? '' : 'hide'}`}>
                                <div className={`parameter-item`}>
                                    <div className="field">
                                        <div className="title">
                                            מספר עובדים
                                        </div>
                                        <div className="value">
                                            <input type="text" value={dataForEdit.workerNumber} onChange={(e: any) => onParamChange('workerNumber', e.target.value)} />
                                        </div>

                                    </div>
                                </div>
                                <div className={`parameter-item`}></div>
                                <div className={`parameter-item`}></div>
                                <div className={`parameter-item`}></div>
                            </div>
                        </div>
                        <div className="client-tab-content-block client-details company-details hide">
                            <div className="tab-content-title">
                                פרטים אישיים
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            &nbsp;
                                        </div>
                                        <div className="value toggle">
                                            <input type="radio" className="toggle-input client-type client-type-personal" id="private02" name="client_type02" data-type="personal" value="private" onClick={emptyFunc} />
                                            <label>
                                                לקוח פרטי
                                            </label>
                                            <input type="radio" className="toggle-input client-type client-type-company" id="company02" name="client_type02" data-type="company" value="company" checked onClick={emptyFunc} />
                                            <label>
                                                חברה
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            ח.פ
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם העסק
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם העסק
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                <span>
                                    אנשי קשר
                                </span>

                                <button className="button blue has-icon only-icon">
                                    <div className="icon add" onClick={addNewContact}></div>
                                </button>
                            </div>
                            <div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item checkbox">
                                    <div className="title">
                                        עיקרי
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        שם
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        אימייל
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        טלפון/פקס
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        הערות
                                    </div>
                                </div>
                                <div className="parameter-item action"></div>
                            </div>
                            {
                                dataForEdit.customerContactDetails && dataForEdit.customerContactDetails.length > 0 ? (<>
                                    {
                                        dataForEdit.customerContactDetails.map((contact: CustomerContactDetailsModel, i: number) => {
                                            return (
                                                <ClientContact contact={contact} key={i} index={i} config={{
                                                    canBeDeleted: dataForEdit.customerContactDetails && dataForEdit.customerContactDetails.length > 1,
                                                    onChange: (contact: CustomerAddressModel) => onContactChange(contact, i),
                                                    onDelete: (contact: any) => onContactDelete(contact, i)
                                                }} />
                                            )

                                        })}
                                </>) : (<>
                                </>)
                            }
                        </div>
                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                <span>
                                    כתובות
                                </span>

                                <button className="button blue has-icon only-icon pointer">
                                    <div className="icon add" onClick={addNewAddress}></div>
                                </button>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="title">
                                        ישוב
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        רחוב
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        מספר
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        דירה
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        כניסה
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        ת.ד
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        מיקוד
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        כתובת משלוח
                                    </div>
                                </div>
                                <div className="parameter-item action">
                                </div>
                            </div>
                            {dataForEdit.customerAddresses ? (<>
                                {dataForEdit.customerAddresses.map((address: CustomerAddressModel, i: number) => {
                                    return (
                                        // <ClientAddress config={{
                                        //     cities: props.config.cities,
                                        //     onChange: (address: CustomerAddressModel) => onAddressChange(address, i),
                                        //     onDelete: (address: CustomerAddressModel, key: number) => onAddressDelete(address, key)
                                        // }} customerAddress={address} index={i} />
                                        <ClientAddress
                                            key={address.id ?? i} // better: always a real id, fallback i if you must
                                            config={{
                                                cities: props.config.cities,
                                                onChange: (addr: CustomerAddressModel) => onAddressChange(addr, i),
                                                onDelete: () => onAddressDelete(i),
                                            }}
                                            customerAddress={address}
                                            index={i}
                                        />
                                    )
                                })}
                            </>) : (<></>)}
                        </div>

                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                רשיון
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="title">
                                        מספר רשיון
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        סוג רשיון
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="title">
                                        תאריך קבלת רשיון
                                    </div>
                                </div>
                                <div className="parameter-item">
                                </div>
                            </div>

                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="value">
                                            <input type="text" value={dataForEdit.driverLicenseNumber} onChange={(e: any) => onParamChange('driverLicenseNumber', e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="value">
                                            <input type="text" value={''} />
                                            <div className="icon small-icon select-arrow pointer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="value">
                                            <CompDatePicker value={driverLicensIssueDate} onChange={(date: Date) => onDateChange('driverLicensIssueDate', date)} />

                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item"></div>
                            </div>
                        </div>
                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                עבודה
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מקום עבודה
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            תפקיד
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                            <div className="icon small-icon select-arrow pointer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מספר עובד
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                            <div className="icon small-icon select-arrow pointer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            משכורת
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מקצוע
                                        </div>
                                        <div className="value">
                                            <input type="text" value={''} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                פרטים נוספים
                            </div>

                        </div>
                    </div>
                    <div className="client-tab-action-row">
                        <button className='btn-save' onClick={save}>
                            <div className="icon icon-save"></div>
                            <div className="label">
                                שמירה
                                <img src={require("../assets/images/loading.gif")} className={loadingSave ? "loadingGif" : "hide"} />
                            </div>

                        </button>
                        <button id="btn-cancel-edit" onClick={turnViewMode}>
                            <div className="icon icon-x"></div>
                            <div className="label">
                                ביטול
                            </div>
                        </button>
                    </div>
                </div>
                <div className="left-side">
                    <div className='inner vert-scrolling'>
                        <div className="client-tab-content-block">
                            <div className="rating-circle-row">
                                <div className="rate-circle">
                                    4
                                </div>
                            </div>
                            <div className="tab-content-title align-center">
                                דירוג
                            </div>
                            <div className="rating-data-row">
                                <div className="rating-item">
                                    <div className="value">
                                        {props.tabData && props.tabData.personalData ? props.tabData.personalData.policyCount : 0}
                                    </div>
                                    <div className="label">
                                        מספר פוליסות אלמנטרי בתוקף
                                    </div>
                                </div>
                                <div className="rating-item">
                                    <div className="value">
                                        0
                                    </div>
                                    <div className="label">
                                        מספר פוליסות חיים בתוקף
                                    </div>
                                </div>
                                <div className="rating-item">
                                    <div className="value">
                                        4
                                    </div>
                                    <div className="label">
                                        ותק בשנים בנח ביטוח
                                    </div>
                                </div>
                                <div className="rating-item">
                                    <div className="value">
                                        0
                                    </div>
                                    <div className="label">
                                        מספר תביעות שהוגשו
                                    </div>
                                </div>
                                <div className="rating-item">
                                    <div className="value">
                                        6
                                    </div>
                                    <div className="label">
                                        מספר פניות בטיפול שוטף
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                סוכן
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            סוכן
                                        </div>
                                        <div className="value">
                                            <input type="text" placeholder="בחר" />
                                            <div className="icon small-icon select-arrow pointer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מטפל
                                        </div>
                                        <div className="value">
                                            <input type="text" placeholder="בחר" />
                                            <div className="icon small-icon select-arrow pointer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            קבוצה
                                        </div>
                                        <div className="value">
                                            <input type="text" placeholder="בחר" />
                                            <div className="icon small-icon select-arrow pointer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מספר תיק
                                        </div>
                                        <div className="value">
                                            <input type="text" placeholder="בחר" />
                                            <div className="icon small-icon select-arrow pointer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            אופן הקמה
                                        </div>
                                        <div className="value disabled">
                                            <input type="text" value="העברת בסיס נתונים" disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            תאריך הקמה
                                        </div>
                                        <div className="value disabled">
                                            <input type="text" value="12 במרץ 2020" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                הערות
                            </div>
                            <div className="parameter-row single-item">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            אופן הקמה
                                        </div>
                                        <div className="value">
                                            <textarea></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-tab-content-block">
                            <div className="tab-content-title">
                                הודעה קופצת
                            </div>
                            <div className="parameter-row single-item">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="value">
                                            <textarea></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`client-tab-content client-details-view-mode ${tab == 'CustomerCard' && mode == ViewMode.VIEW ? '' : 'hide'}`}>
                <ClientDetailsViewMode personalData={personalData} IdentityType={IdentityType} customerAge={customerAge} genders={genders} martialStatuses={martialStatuses}
                    addressTypes={addressTypes} turnEditMode={() => turnEditMode()} />

            </div>
            <div className={`client-tab-content client-treatments-list ${tab == 'Treatment' ? '' : 'hide'}`}>
                <TasksClientDetails treatmentsList={treatmentsList} customerId={props.customerId} setLoading={props.setLoading}
                    showTreatmentConfigPopup={showTreatmentConfigPopup} showAddTreatmentPopup={showPopUpTreatment}
                />
            </div>
            <div className={`client-tab-content client-policies-list ${tab == 'Polices' ? '' : 'hide'}`}>
                <PoliciesClientDetails
                    customerId={props.customerId}
                    config={props.config}
                    displayClientDocument={displayClientDocument}

                    getPolicies={getPolicies}
                    policiesList={policiesList}
                    ridersList={ridersList}
                    policyTypes={policyTypes}
                    allRowsCounter={allRowsCounter}
                    showPopUpTreatment={showPopUpTreatment}
                    customerData={personalData.customerData}
                />
                
            </div>
            <div className={`client-tab-content client-leads-list ${tab == 'Suggestions' ? '' : 'hide'}`}>
                <div className="flex-space-between">
                    <div className="filter-row flex-centered client-search">
                        <div className="filter-input search">
                            <input type="text" value={leadsSearchText} placeholder="חיפוש" onChange={handleLeadsSearchChange} />
                            <div className="icon search"></div>
                        </div>
                        <div className="filter-input select treatment-type-select">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="סוג ביטוח"
                                value={leadsFilter.policyType ? leadsFilter.policyType : '0'}
                                onChange={onPolicyFilterPolcyTypeChange}
                                options={leadPolcyTypes}
                            />
                        </div>
                        <div className="filter-input select">
                            <Select
                                style={{ width: '100%' }}
                                placeholder="סטטוס"
                                value={leadsFilter.StatusIdSearch ? leadsFilter.StatusIdSearch : '0'}
                                onChange={onLeadsFilterStatusChange}
                                options={leadStatuses}
                            />
                        </div>

                        <div className="filter-button">
                            <button type="button" className="button blue has-icon flex-centered flex-justify-center">
                                <div>
                                    חיפוש מתקדם
                                </div>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </button>

                        </div>
                        <div className="filter-button">
                            <div className="icon refresh-counter pointer" onClick={clearLeadsFilter}></div>
                        </div>
                    </div>
                    <div className='flex-centered'>
                        <div className="icon icon-config gear pointer" onClick={showTreatmentConfigPopup}></div>
                    </div>
                </div>
                <div className="content-body leads-table-container">
                    <LeadsTable data={leadsList} />
                </div>
                <footer className="footer emails-list-footer emails-list-view">
                    <Pagger pagerConf={suggestionsPagerConf} changePage={emptyFunc} refresh={emptyFunc}></Pagger>
                </footer>
            </div>
            <div className={`client-tab-content ${tab == 'Problems' ? '' : 'hide'}`}>
                <Sues
                    showTabs={false}
                    customerId={props.customerId}
                    onClaimEdit={(id: string | null, data?: any) => props.config.onClaimCreate ? props.config.onClaimCreate(id, data) : emptyFunc()}
                />
            </div>


            <div className={`client-tab-content documents-list ${tab == 'Documents' ? '' : 'hide'}`}>

                <PoliciesDocumentsClientDetails
                    customerId={props.customerId}
                    documentsList={documentsList}
                    setLoading={props.setLoading}
                    documentsAllData={documentsAllData}
                    displayClientDocument={displayClientDocument}
                    showAddTreatmentPopup={showPopUpTreatment}
                />

            </div>
            <div className={`client-tab-content ${tab == 'WhatsApp' ? '' : 'hide'}`}>
                <div className="content-body">
                    <div className="filter-row flex-centered flex-space-between">
                        <div className="filter-row flex-centered client-search">
                            <div className="filter-input search">
                                <input type="text" placeholder="חיפוש" />
                                <div className="icon search"></div>
                            </div>
                            <div className="filter-input select">
                                <DatePicker
                                    ref={OpenDateFromRef}
                                    selected={null}
                                    onChange={emptyFunc}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </div>
                            <div className="filter-input select">
                                <DatePicker
                                    ref={OpenDateFromRef}
                                    selected={null}
                                    onChange={emptyFunc}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </div>
                        </div>
                        <button type="button" className="button blue has-icon flex-centered flex-justify-center pointer" onClick={gotoWhatsApp}>
                            מעבר לתכתובת
                        </button>
                    </div>
                    <div className="content-table-header flex-space-between flex-centered">
                        <div>
                            תאריך
                        </div>
                        <div>
                            הודעה
                        </div>
                        <div>
                            נשלח/התקבל
                        </div>
                    </div>
                    {whatsAppItemsList ? (<>
                        {whatsAppItemsList.map((whatsAppMessage: SueModel) => {
                            return (
                                <>
                                    <ClientWhatsAppMessage whatsAppMessageDetails={whatsAppMessage} config={{}} />
                                </>
                            )
                        })}
                    </>) : (<></>)}

                </div>
            </div>
            <div className={`client-tab-content calls-tab-content ${tab == 'Calls' ? '' : 'hide'}`}>
                <div className="content-body">
                    <div className="filter-row flex-centered client-search">
                        <div className="filter-input select">
                            <CompDatePicker onChange={emptyFunc} value={null} />
                        </div>
                        <div className="filter-input select">
                            <Select
                                style={{ width: '100%' }}
                                options={[
                                    {
                                        label: 'Answered',
                                        value: 'ANSWERED'
                                    },
                                    {
                                        label: 'Busy',
                                        value: 'BUSY'
                                    },
                                    {
                                        label: 'Failed',
                                        value: 'FAILED'
                                    },
                                    {
                                        label: 'No Answer',
                                        value: 'NOANSWER'
                                    },
                                ]}
                            />
                        </div>
                        <div className="filter-button">
                            <div className="icon refresh-counter pointer" onClick={emptyFunc}></div>
                        </div>

                    </div>
                    <CallsTable data={callItemsList} />

                    <footer className="footer emails-list-footer emails-list-view">
                        <Pagger pagerConf={callsPagerConf} changePage={emptyFunc} refresh={emptyFunc}></Pagger>
                    </footer>
                </div>
            </div>
        </div>
    )
}
export default ClientDetails;